import React from 'react';
import { useSpring, animated } from 'react-spring';
import { styled } from '@linaria/react';

import { random, normalize } from '@/utils';

const LoadingSlider = ({
  isPoweredOn,
  prefersReducedMotion,
  width = 20,
  height = 52,
}: {
  isPoweredOn: boolean;
  prefersReducedMotion: boolean;
  width?: number;
  height?: number;
}) => {
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    if (!isPoweredOn) {
      setValue(0);
      return;
    }

    let timeoutId: number;

    const update = () => {
      setValue(random(0, 100));

      // When "Reduce motion" is ticked, we disable the animation. We'll also increase the amount of time between jumps, since it feels a bit chaotic without the motion.
      const minTime = prefersReducedMotion ? 2000 : 800;
      const maxTime = prefersReducedMotion ? 4000 : 1600;

      timeoutId = window.setTimeout(update, random(minTime, maxTime));
    };

    timeoutId = window.setTimeout(update, random(200, 600));

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isPoweredOn, prefersReducedMotion]);

  const spring = useSpring({
    transform: `translateY(${normalize(value, 0, 100, 4, -height + 4)}px)`,
    immediate: prefersReducedMotion,
  });

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 52"
      fill="none"
    >
      <rect x="2" width="16" height="52" rx="4" fill="#2B2B2B" />
      <line
        x1="6"
        y1="5"
        x2="14"
        y2="5"
        stroke="#fff"
        strokeOpacity="0.51"
        strokeWidth="2"
      />
      <line
        x1="6"
        y1="11"
        x2="14"
        y2="11"
        stroke="#fff"
        strokeOpacity="0.51"
        strokeWidth="2"
      />
      <line
        x1="6"
        y1="17"
        x2="14"
        y2="17"
        stroke="#fff"
        strokeOpacity="0.51"
        strokeWidth="2"
      />
      <line
        x1="6"
        y1="23"
        x2="14"
        y2="23"
        stroke="#fff"
        strokeOpacity="0.51"
        strokeWidth="2"
      />
      <line
        x1="6"
        y1="29"
        x2="14"
        y2="29"
        stroke="#fff"
        strokeOpacity="0.51"
        strokeWidth="2"
      />
      <line
        x1="6"
        y1="35"
        x2="14"
        y2="35"
        stroke="#fff"
        strokeOpacity="0.51"
        strokeWidth="2"
      />
      <line
        x1="6"
        y1="41"
        x2="14"
        y2="41"
        stroke="#fff"
        strokeOpacity="0.51"
        strokeWidth="2"
      />
      <line
        x1="6"
        y1="47"
        x2="14"
        y2="47"
        stroke="#fff"
        strokeOpacity="0.51"
        strokeWidth="2"
      />
      <animated.rect
        y={height - 8}
        width="20"
        height="8"
        rx="4"
        fill="#FF27FF"
        style={spring}
      />
    </Svg>
  );
};

const Svg = styled.svg`
  display: block;
  overflow: visible;
  backface-visibility: hidden;
  fill: none;
`;

export default LoadingSlider;
